import { db, storage, timestamp } from '@/firebaseConfig'

export default {
  state: {
    totalSuppliers: null,
    suppliers: [],
    allSuppliersProducts: {},
    suppliersCounter: null, // store the number of all suppliers in firestore[independets + businesses]
    lastIndSupplierDoc: null,
    lastBusSupplierDoc: null
  },
  mutations: {
    setTotal(state, totalSuppliers) {
      state.totalSuppliers = totalSuppliers
    },
    setSuppliers(state, suppliers) {
      state.suppliers.push(...suppliers)
    },
    resetSuppliers(state) {
      state.suppliers = []
    },
    addSupplier(state, supplier) {
      state.suppliers.push(supplier)
    },
    setSuppliersCounter(state, counter) {
      state.suppliersCounter = counter
    },
    setLastIndSupplierDoc(state, doc) {
      state.lastIndSupplierDoc = doc
    },
    setLastBusSupplierDoc(state, doc) {
      state.lastBusSupplierDoc = doc
    },
    deleteSupplier(state, supplier) {
      const index = state.suppliers.indexOf(supplier)
      state.suppliers.splice(index, 1)
    },
    setSupplierProducts(state, { supplierId, supplierProducts }) {
      state.allSuppliersProducts[supplierId] = supplierProducts
    },
    addSupplierProducts(state, { supplierId, supplierProducts }) {
      state.allSuppliersProducts[supplierId].push(...supplierProducts)
    },
    addProductToAllSuppliersProducts(state, product) {
      state.allSuppliersProducts[product.supplierId].push(product)
    },
    updateProductFromAllSuppliersProducts(state, { product, supplierId }) {
      const productIndex = state.allSuppliersProducts[supplierId].findIndex(
        item => item.id === product.id
      )
      if (productIndex || productIndex === 0) {
        state.allSuppliersProducts[supplierId].splice(productIndex, 1, product)
      }
    },
    deleteProductFromAllSuppliersProducts(state, { product, supplierId }) {
      const productIndex = state.allSuppliersProducts[supplierId].findIndex(
        item => item.id === product.id
      )
      if (productIndex || productIndex === 0) {
        state.allSuppliersProducts[supplierId].splice(productIndex, 1)
      }
    }
  },
  actions: {
    async updateFieldsInFirestore({ _ }) {
      /**
       * For a small database forEach is enough
       * but as the database grows, consider splitting the data in small batches
       */

      /**
       * TODO
       * 1. add `favoriteProductsIds`
       */
      // const inds = await db.collection('independents').get()

      // inds.forEach(async(ind) => {
      //   // update every collection except counter
      //   const favPath = `${ind.ref.path}/supplierData/favoriteProductsIds`
      //   const favoriteProductsIds = await db.doc(favPath).get()

      //   console.log('favoriteProductsIds: ', favoriteProductsIds)

      //   // if (messages.size === 0 && business.id !== 'counter') {
      //   //   await db.doc(`${messagesPath}/contactedProductsIds`).set({ ids: [] }, { merge: true })
      //   //   console.log(`Updating supplier ${business.id}`)
      //   // }
      // })

      /**
       * TODO
       * 1. add createdAtMills to business products
       */
      // const bus = await db.collection('independents').get()

      // bus.forEach(async(b) => {
      //   // update every product except counter
      //   const prodsPath = `${b.ref.path}/products`
      //   const products = await db.collection(prodsPath).get()

      //   products.forEach(p => {
      //     const product = p.data()
      //     if (product.created_at_mills === '') {
      //       console.log(product.createdAt.toMillis().toString())
      //       console.log(p.ref.path)
      //       // db.doc(p.ref.path).update({ created_at_mills: product.createdAt.toMillis().toString() })
      //     }
      //   })
      // })

      /**
       * TODO
       * update every indepedent supplier to have messages field
       */
    },
    fetchAdminData({ commit }, admin) {
      const newUser = {
        id: admin.uid,
        name: admin.displayName,
        isAdmin: true,
        isAccountVerified: true,
        type: 'admin'
      }
      commit('setUser', newUser)
    },
    async getSuppliersCounter({ commit }) {
      const busCounter = await db.doc('independents/counter').get()
      const indCounter = await db.doc('businesses/counter').get()
      commit('setSuppliersCounter', busCounter.data().size + indCounter.data().size)
    },

    // TODO: implement pagination
    // TODO: limit to 5 independent and5 business on the first connection
    // TODO: create a collectionGroup called supplierData and use that to retrive with pagination
    // .limit(5)
    // load 5 independent and5 business
    // load products for each when clicked
    async getSuppliers({ commit }) {
      commit('setLoading')
      const suppliers = await db.collectionGroup('supplierData').orderBy('created_at_mills', 'desc').get()

      suppliers.forEach(doc => {
        commit('addSupplier', doc.data())
      })

      commit('clearLoading')
    },

    getSupplierProducts({ commit }, supplier) {
      return new Promise((resolve, reject) => {
        const productsPath = supplier.type === 'business' ? `businesses/${supplier.id}/products` : `independents/${supplier.id}/products`
        db.collection(productsPath).get()
          .then(snap => {
            const data = []
            snap.forEach(doc => {
              data.push(doc.data())
            })
            const supplierProducts = data.filter(product => product.created_at_mills)
            commit('setSupplierProducts', { supplierId: supplier.id, supplierProducts })
            resolve({ products: supplierProducts })
          })
          .catch(err => reject(err))
      })
    },

    createIndSupplier({ commit }, supplier) {
      return new Promise((resolve, reject) => {
        const newSupplierRef = db.collection('independents').doc()

        const newSupplier = {
          ...supplier,
          id: newSupplierRef.id,
          isAccountVerified: false,
          isAccountApproved: true,
          hasFinishedAccountSetup: false,
          createdBy: 'admin',
          createdAt: timestamp,
          updatedAt: timestamp,
          created_at_mills: '',
          creationError: '',
          isAdmin: false
        }

        const publicFields = {
          created_at_mills: '',
          phoneNumber: supplier.phoneNumber,
          type: supplier.type
        }

        // add supplier's products counter
        db.doc(`/independents/${newSupplier.id}/products/counter`).set({ size: 0 }).catch(err => reject(err))

        // add independent supplier in firestore
        db.doc(`/independents/${newSupplier.id}`).set(publicFields).catch(err => reject(err))

        /** add an array to store ids of favoriteProductsIds */
        db.doc(`/independents/${newSupplier.id}/customerData/favoriteProductsIds`).set({ ids: [] }, { merge: true })

        db.doc(`/independents/${newSupplier.id}/supplierData/details`)
          .set(newSupplier)
          .then(() => {
            /**
             * add independent supplier in local store
             * to solve updated error (TypeError: Converting circular structure to JSON) and button not showing up after creating supplier,
             * delete createdAt and updatedAt properties
             */
            delete newSupplier.createdAt
            delete newSupplier.updatedAt
            commit('addSupplier', newSupplier)
            resolve()
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    createBusSupplier({ commit }, supplier) {
      return new Promise((resolve, reject) => {
        const newSupplierRef = db.collection('businesses').doc()

        const newSupplier = {
          ...supplier,
          id: newSupplierRef.id,
          isAccountVerified: false,
          isAccountApproved: true,
          hasFinishedAccountSetup: false,
          createdBy: 'admin',
          createdAt: timestamp,
          updatedAt: timestamp,
          created_at_mills: '',
          creationError: '',
          isAdmin: false
        }

        const publicFields = {
          created_at_mills: '',
          phoneNumber: supplier.phoneNumber,
          type: supplier.type,
          companyName: supplier.companyName
        }

        // add supplier's products counter
        db.doc(`/businesses/${newSupplier.id}/products/counter`).set({ size: 0 }).catch(err => reject(err))

        // add independent supplier in firestore
        db.doc(`/businesses/${newSupplier.id}`).set(publicFields).catch(err => reject(err))

        /** add an array to store ids of favoriteProductsIds */
        db.doc(`/businesses/${newSupplier.id}/customerData/favoriteProductsIds`).set({ ids: [] }, { merge: true }).catch(err => reject(err))

        db.doc(`/businesses/${newSupplier.id}/supplierData/details`)
          .set(newSupplier)
          .then(() => {
            /**
             * add business supplier in local store
             * to solve updated error (TypeError: Converting circular structure to JSON) and button not showing up after creating supplier,
             * delete createdAt and updatedAt properties
             */
            delete newSupplier.createdAt
            delete newSupplier.updatedAt
            commit('addSupplier', newSupplier)
            resolve()
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    updateSupplier({ commit }, payload) {
      return new Promise((resolve, reject) => {
        const supplier = payload.supplier

        // update updatedAt
        // use a copy
        const updatedSupplier = {
          ...supplier,
          updatedAt: timestamp
        }

        const supplierPath = supplier.type === 'business' ? `businesses/${supplier.id}` : `independents/${supplier.id}`

        /**
         * if phone number, update publicFields
         */
        if (payload.isNewPhoneNumber) {
          db.doc(supplierPath).update({ phoneNumber: supplier.phoneNumber }).catch(err => reject(err))
        }

        // user the merge option to avoid accidentally replacing the whole document
        db.doc(`${supplierPath}/supplierData/details`).set(updatedSupplier, { merge: true })
          .then(() => {
            resolve('supplier updated sucessfully')
          })
          .catch(err => {
            reject(err)
          })
          /**
           * not need to update supplier in the store, as has already been done, execpt the upadatedAt field
           * on next refresh everything will be updated
           * commit('updateSupplier', supplier))
           * */
      })
    },

    deleteSupplier({ commit }, supplier) {
      return new Promise((resolve, reject) => {
        const docPath = supplier.type === 'business' ? `businesses/${supplier.id}` : `independents/${supplier.id}`
        const productsPath = `${docPath}/products`
        /**
         * Warning: Deleting a document does not delete its subcollections!
         * You can still access the subcollection documents by reference
         * Non-existent ancestor documents appear in the console, but they do not appear in query results and snapshots.
         */
        /**
         * delete the supplier doc
         */
        db.doc(docPath).delete()
          .then(() => {
            /**
             * delete supplier details document
             */
            const detailsRef = db.doc(`${docPath}/supplierData/details`)
            detailsRef.delete()

            db.collection(productsPath).get()
              .then((snap) => {
                /**
                 * delete the products counter first
                 * and remove if from the documents
                 */
                const counterRef = db.doc(`${productsPath}/counter`)
                counterRef.delete()
                const filteredDocuments = snap.docs.filter(item => item.ref.path !== `${productsPath}/counter`)
                filteredDocuments.forEach((doc) => {
                  /**
                   * delete images associated from storage
                   * get images array
                   * for there's only one single image
                   * TODO: Delete all images if a product has more than one (future updates)
                   * TODO: Delete compressed also
                   */
                  const imgRef = doc.ref.path
                  storage.ref().child(imgRef).delete()
                    .then(() => {
                      /**
                       * delete the product document
                       */
                      doc.ref.delete()
                        .then(() => resolve())
                        .catch(err => reject(err))
                    })
                    .catch(err => reject(err))
                })
              })
              .catch(err => reject(err))
            commit('deleteSupplier', supplier)
          })
          .catch(err => reject(err))
      })
    }
  },
  getters: {
    totalSuppliers(state) {
      return state.totalSuppliers
    },
    suppliers(state) {
      return state.suppliers
    },
    supplier: state => id => {
      return state.suppliers.find(supplier => supplier.id === id)
    },
    // TODO: not used yet !
    // Use it instead of querying the DB
    getSupplierProducts: state => id => {
      return state.allSuppliersProducts[id]
    },
    suppliersCounter(state) {
      return state.suppliersCounter
    },
    lastIndSupplierDoc(state) {
      return state.lastIndSupplierDoc
    },
    lastBusSupplierDoc(state) {
      return state.lastBusSupplierDoc
    }
  }
}
